import React from 'react';
import { cn } from '@/lib/utils';
import { SUPPORT_TICKET_STATUS_LABELS, type SupportTicketStatus } from '@/services/supportTicketService';

const STYLES: Record<SupportTicketStatus, string> = {
  open: 'border-[#1967D2]/30 bg-[#1967D2]/10 text-[#1967D2]',
  in_progress: 'border-[#1967D2]/30 bg-[#1967D2]/10 text-[#1967D2]',
  // Der Ball liegt beim Salon -- deshalb die einzige auffällige Farbe.
  waiting_for_customer:
    'border-amber-300 bg-amber-50 text-amber-800 dark:border-amber-500/40 dark:bg-amber-500/10 dark:text-amber-300',
  resolved:
    'border-emerald-300 bg-emerald-50 text-emerald-800 dark:border-emerald-500/40 dark:bg-emerald-500/10 dark:text-emerald-300',
  withdrawn: 'border-border bg-muted text-muted-foreground',
};

export function SupportTicketStatusBadge({ status, className }: { status: SupportTicketStatus; className?: string }) {
  return (
    <span
      className={cn(
        'inline-flex items-center whitespace-nowrap rounded-full border px-2.5 py-0.5 text-xs font-medium',
        STYLES[status],
        className,
      )}
    >
      {SUPPORT_TICKET_STATUS_LABELS[status]}
    </span>
  );
}
